export const COMMON_TEXT = {
  CREATE: 'common.create',
  DASHBOARD: 'dashboard',
  DELETE: 'common.delete',
  FALSE: 'common.false',
  GOOD_DAY: 'good_day',
  INSPECTION_MANAGEMENT: 'inspection_management',
  LANGUAGES: 'languages',
  LOGOUT: 'common.logout',
  MENU: 'menu',
  NEW_ROLE: 'new_role',
  NEW_USER: 'new_user',
  ORDER_MANAGEMENT: 'order_management',
  PASSWORD: 'common.password',
  SEARCH_USER: 'placeholder.search_user',
  SYSTEM_CONFIGURATION: 'system_configuration',
  TRUE: 'common.true',
  UPDATE: 'common.update',
  VIEW: 'common.view',
}
